/****
 * vivialconnect-js-core
 * JS utilities to support JS interactions with the Vivial Connect API.
 * This library must be initialized with a configuration object containing
 * information about the app.
 *
 * Usage:
 *
 * import VivialConnectJSCore from "vivialconnect-js-core";
 * const { auth } = VivialConnectJSCore({
 *     BASE_URL: https://api.vivialconnect.net/api/v1.0
 *     OAUTH: {
 *       URL: https://api.vivialconnect.net,
 *       CLIENT_ID: "[ID]",
 *       CLIENT_SECRET: "[SECRET]",
 *     }
 * });
 *
 * auth.login(uname, pword);
 *
 */

import storage from "./src/core/storage.js";
import http from "./src/core/http.js";
import appSessionStore from "./src/helpers/appSessionStore.js";
import token from "./src/helpers/token.js";
import factory from "./src/helpers/factory.js";
import numbers from "./src/helpers/numbers.js";
import validation from "./src/helpers/validation.js";
import stringUtils from "./src/helpers/stringUtils.js";
import customHooks from "./src/helpers/customHooks";
import auth from "./src/services/auth/index.js";

const configTemplate = {
  // APP_NAME: "vivialconnect",
  BASE_URL: null,
  OAUTH: {
    URL: null,
    CLIENT_ID: null,
    CLIENT_SECRET: null,
    GRANT_TYPE: "password",
    TOKEN_TYPE_HINT: "access_token",
  },
  COOKIE: {
    TOKEN_NAME: "token",
    TOKEN_EXPIRE_IN_MINUTES: 1,
  },
};

export { factory };
export default function VivialConnectJSCore(_config) {
  //validate config
  if (
    typeof _config !== "object" ||
    typeof _config.OAUTH !== "object" ||
    _config.BASE_URL === undefined ||
    _config.OAUTH.URL === undefined ||
    _config.OAUTH.CLIENT_ID === undefined ||
    _config.OAUTH.CLIENT_SECRET === undefined
  ) {
    throw "vivialconnect-js-core missing or invalid configuration";
  }

  const config = {
    ...configTemplate,
    ..._config,
  };

  const api_components = {
    config,
    storage,
    appSessionStore,
    token,
    http,
    auth,
  };

  //initialize components with config + references to all other components
  for (const [name, component] of Object.entries(api_components)) {
    if (typeof component.init === "function") component.init(api_components);
  }

  return {
    config,
    core: {
      storage,
      http,
    },
    helpers: {
      appSessionStore,
      token,
      numbers,
      validation,
      stringUtils,
      customHooks,
      storage,
    },
    services: {
      auth,
    },
  };
}
